$.fn.evouchers = function () {
	var dateFormat = 'dd/mm/yy';

	$evoucherWrapper = $(this),
		$dateFilterInput = $evoucherWrapper.find('.evouchers__date-filter__input'),
		$evouchersList = $evoucherWrapper.find('.evouchers__list'),
		$noVouchersZone = $evoucherWrapper.find('.no-vouchers-zone'),
		$evouchersListItems = $evoucherWrapper.find('.evouchers__list__item'),
		$categoryLinks = $evoucherWrapper.find('.category-link'),
		$defaultWidgetZoneArea = $evoucherWrapper.find('.default-widget-zone-area'),
		$checkboxes = $evoucherWrapper.find('.evouchers__list__checkbox input[type=checkbox]'),
		$sendButton = $evoucherWrapper.find('.evouchers__send-btn'),
        $filterCategory = $evoucherWrapper.find('.evouchers__filter-category input[type=hidden]'),
        $infoLinks = $evoucherWrapper.find('.evouchers__list__info-link'),
        $infoBoxes = $evoucherWrapper.find('.evouchers__list__info');

	$dateFilterInput.datepicker({
		showButtonPanel: true,
		dateFormat: dateFormat,
		minDate: 0,
		beforeShow: function (input, inst) {
			$('#ui-datepicker-div').addClass('evouchers__date-filter__date-picker')
		},
		onSelect: function (date, inst) {
		    var parsedDate = $.datepicker.parseDate(dateFormat, date);
		    setCategoryCounts(parsedDate);

			var $categoryLink = $categoryLinks.filter('.is-active');
			if ($categoryLink.length != 1) {
				return;
			}
			displayVouchers(parsedDate, $($categoryLink[0]).data('categoryId'));
			fixVoucherPositioning();
			WizardScroll('.evouchers__list', 25);
		}
	});

	$evouchersList.hide();
	$noVouchersZone.hide();

	$categoryLinks.on('click', function () {
		//fix for tablets & mobile to realign columns
	    salvattore.rescanMediaQueries();
	    toggleCategoryDisplay($(this));
	});

	$infoLinks.on('click', function () {
	    $infoLinks.not(this).removeClass('is-active');
	    $infoBoxes.not(this).removeClass('is-active');
	    $evouchersListItems.css('margin-bottom', '');
        
	    var $infoLink = $(this),
            $infoBox = $infoLink.siblings('.evouchers__list__info'),
            $voucherWrapper = $infoLink.closest('.evouchers__list__item'),
	        $currentRowItems = $evouchersListItems.filter('[data-voucher-row=' + $voucherWrapper.attr('data-voucher-row') + ']');

	    $infoBox.css('top', '');
	    $infoBox.css('width', '');
        
	    if ($infoLink.hasClass('is-active')) {
	        $infoLink.removeClass('is-active');
	        $infoBox.removeClass('is-active');
	    } else {
	        $infoLink.addClass('is-active');
	        $infoBox.addClass('is-active');
	        $infoBox.css('top', $currentRowItems.position().top + getMaxHeightOfElements($currentRowItems));
	        $infoBox.css('width', $evouchersList.outerWidth() * 0.98);
	        $currentRowItems.css('margin-bottom', $infoBox.outerHeight(true));
	    }
	});

	setCheckboxesState();
	setSendButtonState();
	setCategoryCounts();
	if ($filterCategory.val()) {
	    $categoryLink = $categoryLinks.filter('[data-category-id=' + $filterCategory.val() + ']');
	    toggleCategoryDisplay($categoryLink);
	}

	$checkboxes.on('change', function () {
		$(this).closest('li').toggleClass('is-active');
		setSendButtonState();
	});

	$(window).resize(function () {
	    fixVoucherPositioning();
	});
    
	function setSendButtonState() {
		if ($checkboxes.is(':checked')) {
			$sendButton.removeAttr('disabled');
		} else {
			$sendButton.attr('disabled', 'disabled');
		}
	}

	function setCheckboxesState() {
		$checkboxes.each(function () {
		    var $checkbox = $(this);
			$checkbox.closest('li').toggleClass('is-active', $checkbox.is(':checked'));
		});
	}

	function toggleCategoryDisplay($categoryLink) {
	    $categoryLinks.not($categoryLink[0]).removeClass('is-active');
	    $evouchersListItems.hide();

	    if ($categoryLink.hasClass('is-active')) {
	        $filterCategory.val('');
	        $categoryLink.removeClass('is-active');
	        $evouchersList.hide();
	        $noVouchersZone.hide();
	        $defaultWidgetZoneArea.fadeIn();
	    } else {
	        $categoryLink.addClass('is-active');
	        var filterDate = $.datepicker.parseDate(dateFormat, $dateFilterInput.val());
	        var filterCategoryId = $categoryLink.data('categoryId');
	        $filterCategory.val(filterCategoryId);
	        displayVouchers(filterDate, filterCategoryId);
	        $evouchersList.fadeIn(function () {
	            fixVoucherPositioning();
	        });
	        WizardScroll('.evouchers__list', 25);
	    }
	}

	function displayVouchers(filterDate, filterCategoryId) {
	    $evouchersListItems.hide();
		$defaultWidgetZoneArea.hide();
		$noVouchersZone.hide();
		var showNoVouchersMessage = $categoryLinks.is('.is-active');
		$evouchersListItems.each(function () {
			var $voucher = $(this);
			var voucherCategoryId = $voucher.data('categoryId');
			if (voucherCategoryId != filterCategoryId && filterCategoryId != 'all') {
				return;
			}

			var voucherDateValidFrom = $.datepicker.parseDate(dateFormat, $voucher.data('validFrom'));
			var voucherDateValidTo = $.datepicker.parseDate(dateFormat, $voucher.data('validTo'));
			if (voucherDateValidFrom > filterDate || voucherDateValidTo < filterDate) {
				return;
			}

			showNoVouchersMessage = false;
			$voucher.show();
		});
		if (showNoVouchersMessage) {
			$noVouchersZone.fadeIn();
		}
	}

	function fixVoucherPositioning() {
	    var currentRowTop, currentRow = 0;
	    $evouchersListItems.removeClass('evouchers__list__item--first-in-row');
	    $evouchersListItems.attr('data-voucher-row', '');
	    $evouchersListItems.each(function () {
	        var $voucher = $(this);
	        if ($voucher.is(':hidden'))
	            return;

	        if (typeof currentRowTop === 'undefined') {
	            currentRowTop = $voucher.position().top;
	        } else if (currentRowTop != $voucher.position().top) {
	            $voucher.addClass('evouchers__list__item--first-in-row');
	            currentRowTop = $voucher.position().top;
	            currentRow++;
	        }
	        $voucher.attr('data-voucher-row', currentRow);
	    });
	    $infoLinks.removeClass('is-active');
	    $infoBoxes.removeClass('is-active');
	    $infoBoxes.css('top', '');
	    $infoBoxes.css('width', '');
	    $evouchersListItems.css('margin-bottom', '');
	}

	function setCategoryCounts(filterDate) {
	    if (typeof filterDate === 'undefined') {
	        filterDate = $.datepicker.parseDate(dateFormat, $dateFilterInput.val());
	    }
	    var categoryCounts = [0, 0];
		$evouchersListItems.each(function () {
			var $voucher = $(this);
			var voucherCategoryId = $voucher.data('categoryId');
			var voucherDateValidFrom = $.datepicker.parseDate(dateFormat, $voucher.data('validFrom'));
			var voucherDateValidTo = $.datepicker.parseDate(dateFormat, $voucher.data('validTo'));
			if (voucherDateValidFrom > filterDate || voucherDateValidTo < filterDate) {
				return;
			}
			categoryCounts[voucherCategoryId]++;
		});
		$('.evouchers__category-filter__item[data-category-id=0] .evouchers__category-filter__count').text('(' + categoryCounts[0] + ')');
		$('.evouchers__category-filter__item[data-category-id=1] .evouchers__category-filter__count').text('(' + categoryCounts[1] + ')');
		$('.evouchers__category-filter__item[data-category-id=all] .evouchers__category-filter__count').text('(' + (categoryCounts[0]+categoryCounts[1]) + ')');
	}

	function getMaxHeightOfElements($els) {
	    return Math.max.apply(null, $els.map(function () {
	        return $(this).outerHeight();
	    }).get());
	}
}